<template>
    <div
        class="w-full rounded-lg flex flex-col justify-center items-center p-8 mt-6"
    >
        <HeaderIcon>
            <HugeiconsIcon :icon="CpuChargeIcon" :size="28" :color="'#5F6D7E'" />
        </HeaderIcon>

        <div class="w-full max-w-lg lg:max-w-2xl xl:max-w-5xl flex flex-col justify-center items-center mt-8 z-50">
            <Intro :heading-text="headingText" :sub-text="subText" />

            <SubscriptionPlanTabs :loading="isLoading" @update:plan="updateSubscriptionPlan" :default-value="formData.payload?.subscription_plan?.name" :yearly="formData.payload?.subscription_plan?.yearly ?? false"></SubscriptionPlanTabs>

            <div class="w-full flex justify-center items-center mt-8">
                <Button variant="link" class="text-sm text-primary-font font-medium" @click="togglePlanDifferenceDialog">
                    What is the difference?
                </Button>
            </div>
        </div>

        <GenericDialog v-model="planDifferenceDialog" class="sm:max-w-2xl">
            <template #title>
                <div class="text-lg font-semibold text-primary-font">
                    Which plan is right for you?
                </div>
            </template>
            <template #body>
                <PlanRecommendations />
            </template>
            <template #footer>
                <div class="w-full flex flex-col justify-center items-center pt-4">
                    <div class="text-base text-primary-gray mb-2">
                        Still not sure which option fits your needs?
                    </div>
                    <Button @click="triggerCall" class="text-white text-sm font-semibold bg-primary-green">
                        <Phone class="w-4 h-4" />
                        <span>
                            Talk to our team
                        </span>
                    </Button>
                </div>
            </template>
        </GenericDialog>
    </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { useSignupWizardStore } from "@/store/signup-wizard";
import HeaderIcon from "./components/HeaderIcon.vue";
import Intro from "./components/Intro.vue";
import SubscriptionPlanTabs from "./components/SubscriptionPlanTabs.vue";
import Button from "@/components/ui/button/Button.vue";
import GenericDialog from "@/components/ui/dialog/GenericDialog.vue";
import PlanRecommendations from "./components/PlanRecommendations.vue";
import { useConfig } from "@/composables/config";
import { storeToRefs } from "pinia";

import { HugeiconsIcon } from '@hugeicons/vue'
import { CpuChargeIcon } from '@hugeicons/core-free-icons'
import { Phone } from "lucide-vue-next";

const signupWizardStore = useSignupWizardStore();

const {formData, isLoading} = storeToRefs(signupWizardStore);
const {fetchSignupState, submitSubscriptionPlan} = signupWizardStore;

const { teamPhone } = useConfig();

const headingText = "What do you want to manage?";
const subText = 'Pick the option that best describes your setup right now. You can change this later.';

const planDifferenceDialog = ref(false);
const setPlanDifferenceDialog = (value) => {
    planDifferenceDialog.value = value;
}

const togglePlanDifferenceDialog = () => {
    setPlanDifferenceDialog(!planDifferenceDialog.value);
}

const triggerCall = () => {
    window.open('tel:' + teamPhone);
}

const updateSubscriptionPlan = async (plan) => {
    formData.value.payload.subscription_plan = {...plan};
    await submitSubscriptionPlan();
}

onMounted(async () => {
    await fetchSignupState();
})
</script>
